export default "../../src/img/lysiq-symbol-3d.jpg";